import zIndex from "@mui/material/styles/zIndex";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "98vh",
      minWidth: "98%",
      maxWidth: "90%",
    },
    "& + .pac-container": {
      zIndex: theme.zIndex.modal + 1
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 20px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 20,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 20px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
  },
  bookingiconbuttonopen:{
    position: "absolute !important",
   // zIndex: 999,
    right: "0px",
    top: "103px", 
    color: "black",
  },
  drawerformbox:{
    width: 425,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
    boxSizing: 'border-box',
    right: 0,
    padding : "25px",
    top: "107px",
    height: "80%",
    zIndex:99,
    },
  },
  bookingformbox:{ 
    width: 400, 
    background: "#fff", 
    borderRadius: 2, 
    margin: "0 auto",
    position:"relative"  
  },
  formboxcloseicon:{
    position: "absolute !important",
    right: "422px",
    top: "92px",
    zIndex:999,
    background:"#000000b5 !important",
    color: "#fff !important",
    cursor: "pointer",
    height: "36px",
    width: "35px",
    transition: "color 0.3s ease",
    "&:hover":{
      color: "#FF0000 !important",
    }
  },
  autocomplete_control:{
  padding : "25px 0px"
  },
  booking_header:{
    color: theme.palette.custom.main,
    paddingTop: 12,
    "& .MuiTypography-h5":{
      fontWeight: 800,
    },
  },
  autocomplete_inputs:{
    flex: 1,
    backgroundColor: "#f8f9fa",
    borderRadius: "25px",
    width:"100%",
    margin: "0px 40px !important",
  }
}));

export default useStyles;
